/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tame_Vivid_Bear_SinkInputs */

const en_tame_vivid_bear_sink = /** @type {(inputs: Tame_Vivid_Bear_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download template`)
};

const de_tame_vivid_bear_sink = /** @type {(inputs: Tame_Vivid_Bear_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage herunterladen`)
};

/**
* | output |
* | --- |
* | "Download template" |
*
* @param {Tame_Vivid_Bear_SinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tame_vivid_bear_sink = /** @type {((inputs?: Tame_Vivid_Bear_SinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tame_Vivid_Bear_SinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tame_vivid_bear_sink(inputs)
	return de_tame_vivid_bear_sink(inputs)
});